module.exports = __webpack_public_path__ + "static/media/regal-rush-white-bg-gold-300x140.d0d27281.png";